import { createFileRoute } from '@tanstack/react-router';

import { InvoicesPage } from '@/features/collections';
import { workspaceSearchSchema } from '@/patterns';
import { currentPeriod } from '@/shared/lib/dates';

export const Route = createFileRoute('/_app/collections/invoices/')({
  validateSearch: workspaceSearchSchema,
  staticData: { crumb: 'collections:nav.invoices' },
  component: function CollectionsList() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    const onSearchChange = (patch: Record<string, unknown>, o?: { replace?: boolean }) =>
      void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: o?.replace ?? false });
    return (
      <InvoicesPage
        search={search}
        period={search.period ?? currentPeriod()}
        bank={search.bank}
        onScopeChange={(patch) => onSearchChange({ ...patch, page: undefined })}
        onSearchChange={onSearchChange}
      />
    );
  },
});
